import type {GridMediaItemStorage, GridMediaItemTag} from '@Components/base-grid/components/grid-media-item';
import {GridMediaItem, GridMediaItemTagType} from '@Components/base-grid/components/grid-media-item';
import type {GridItemProps} from '@Components/base-grid/components/grid-item';
import type {ReactElement} from 'react';
import React, {useState} from 'react';
import styles from './grid-extracted-getty-sticker-item.module.scss';
import {CostTag} from '@Components/cost-tag';
import {SourceTag} from '@Components/source-tag';

export interface GridExtractedGettyStickerItemStorage extends GridMediaItemStorage {
  hashedFilename: string;
  width?: number;
  height?: number;
}

interface GridExtractedGettyStickerItemProps extends GridItemProps {
  thumbSrc: string;
  tag?: GridMediaItemTag;
}

export function GridExtractedGettyStickerItem({...props}: GridExtractedGettyStickerItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const getTag = (): ReactElement<any> => {
    return (
      <div className={`${styles.tagContainer} _full-width _full-height`}>
        {props.tag?.type === GridMediaItemTagType.COST ? (
          <CostTag containerStyle={props.tag.containerStyle} textStyle={props.tag.textStyle} icon={props.tag.icon} price={props.tag.price} />
        ) : (
          <SourceTag containerStyle={props.tag?.containerStyle} contentStyle={props.tag?.iconStyle} />
        )}
      </div>
    );
  };

  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      thumb={
        <>
          <img
            onLoad={(): void => {
              setIsImageLoaded(true);
            }}
            src={props.thumbSrc}
            className={styles.thumb}
            alt={window.i18next.t('pmwjs_sticker')}
            draggable="false"
            loading="lazy"
          />
          {props.tag ? getTag() : null}
        </>
      }
    />
  );
}
